// pull in config vars
import * as config from "../config"
import getJamFilledCookie from "../getJamFilledCookie"
import fetch from "isomorphic-fetch"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"

interface Thread {
	// TODO: What is the shape of the returned JSON?
	_id: string
	location: {
		host: string
		path: string
		selector: string
	}
}

export default async function getThreadById(
	JAM_ID: string,
	threadId: string,
): Promise<Thread | false> {
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/threads/${threadId}`,
			{
				headers: {
					"Content-Type": "application/json",
					"jam-filled-cookie": getJamFilledCookie(),
					"jam-filled-userid": getUserIdFromLocalStorage(),
				},
			},
		)

		const json = await res.json()

		if (
			res.status === 404 ||
			res.status === 403 ||
			res.status === 503 ||
			res.status === 500
		) {
			return false
		}

		return json
	} catch (e) {
		return false
	}
}
